import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from '../../../../styles/dggTheme';
import { breakpoint } from '../../../../styles/dontgiftguide.styles';

const { text, spacing } = dggTheme;

export const tile = css`
  margin: ${pxToRem(spacing.xl)} ${pxToRem(spacing.xxl)};

  ${mediaQuery(
    { min: breakpoint },
    css`
      margin: 0 auto ${pxToRem(spacing.xxxxl)};
    `,
  )}

  a {
    display: block;
    color: inherit;
    text-decoration: none;
  }
`;

export const productImage = css`
  width: 100%;
  height: 217px;
  object-fit: cover;
  border-radius: ${pxToRem(30)};

  ${mediaQuery(
    { min: breakpoint },
    css`
      height: 672px;
    `,
  )}
`;

export const title = css`
  text-align: left;
  width: 212px;
  line-height: normal;
  font-size: ${pxToRem(text.BODY.SM.fontSize)};

  ${mediaQuery(
    { min: breakpoint },
    css`
      font-size: ${pxToRem(text.HEADING.MD.fontSize)};
      width: 617px;
    `,
  )}
`;

export const stickerContainer = css`
  display: inline-block;
  position: absolute;
  bottom: -30px;
  right: -15px;

  ${mediaQuery(
    { min: breakpoint },
    css`
      bottom: -40px;
      right: -65px;
    `,
  )}
`;

export const imageContainer = css`
  position: relative;
`;
